import { Controller } from "@hotwired/stimulus"
import ahoy from "../ahoy_config"

export default class extends Controller {
  connect() {
    // Listen for all clicks on the document body
    this.element.addEventListener("click", this.handleClick.bind(this), { capture: true })

    // Listen for form submissions too
    this.element.addEventListener("submit", this.handleSubmit.bind(this), { capture: true })
  }

  disconnect() {
    this.element.removeEventListener("click", this.handleClick.bind(this), { capture: true })
    this.element.removeEventListener("submit", this.handleSubmit.bind(this), { capture: true })
  }

  handleClick(event) {
    // We only care about interactive elements
    const target = event.target.closest("a, button, input[type='submit'], input[type='button'], .clickable")

    if (!target) return

    // Allow opting out
    if (target.hasAttribute("data-ahoy-skip") || target.closest("[data-ahoy-skip]")) return

    const tagName = target.tagName.toLowerCase()

    // ... (rest of logic)

    const text = (target.innerText || target.value || target.title || "").trim().substring(0, 100)
    const href = target.getAttribute("href") || target.getAttribute("action")
    const id = target.id
    const classes = target.className

    const workspaceId = document.body.dataset.workspaceId
    console.log(`✅ UI Clicked | Text: "${text}" | WS: ${workspaceId}`)

    ahoy.track("UI Clicked", {
      tag: tagName,
      text: text,
      path: window.location.pathname,
      href: href,
      id: id,
      classes: classes,
      workspace_id: workspaceId
    })
  }

  handleSubmit(event) {
    const target = event.target // The form element

    if (target.hasAttribute("data-ahoy-skip") || target.closest("[data-ahoy-skip]")) return

    const action = target.getAttribute("action")
    const method = target.getAttribute("method") || "GET"
    const id = target.id
    const workspaceId = document.body.dataset.workspaceId
    console.log(`✅ Form Submitted | WS: ${workspaceId}`)

    ahoy.track("Form Submitted", {
      tag: "form",
      path: window.location.pathname,
      href: action,
      method: method,
      id: id,
      workspace_id: workspaceId
    })
  }
}
